import { AiApiWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('AI')
export class AINodeConnectorProvider extends ConnectorProvider<AiApiWorkflowNode> {}
